import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'allowedActions'
})
export class AllowedActionsPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    console.log(value)
    console.log(args)
    return null;
  }

}
